import {
  NotificationResponse,
  NotificationSearchParams,
  CreateNotificationCommand,
  CreateSubscriptionCommand,
  AlertResponse
} from '@/types/notification'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'
import { AxiosResponse } from 'axios'

/**
 * @description read https://api-staging.cisgenics.com/notification/swagger/index.html
 * ObjectId: is InterfaceId
 */
const notificationApi = {
  getNotifications(
    searchParams: NotificationSearchParams = {}
  ): Promise<AxiosResponse<NotificationResponse>> {
    const url = '/notification/api/Notification'
    return axiosClient.get(url + queryStringify(searchParams))
  },

  getNotificationsByObjectId(
    objectId: string,
    searchParams: Omit<NotificationSearchParams, 'ObjectId'> = {}
  ): Promise<AxiosResponse<NotificationResponse>> {
    const url = '/notification/api/Notification'
    return axiosClient.get(url + queryStringify({ ObjectId: objectId, ...searchParams }))
  },

  createNotification(
    payload: CreateNotificationCommand
  ): Promise<AxiosResponse<AlertResponse>> {
    const url = '/notification/api/Notification'
    return axiosClient.post(url, payload)
  },

  getSubscription(
    objectId: string,
    userEmail: string
  ): Promise<AxiosResponse<any>> {
    const url = `/notification/api/Notification/${objectId}/${userEmail}`
    return axiosClient.get(url)
  },

  createOrUpdateSubscription(
    payload: CreateSubscriptionCommand
  ): Promise<AxiosResponse<void>> {
    const url = '/notification/api/Notification/tags'
    return axiosClient.put(url, payload)
  },

  updateSubscriptionInfo(
    payload: { email: string; phoneNumber?: string; measure?: string; language?: string }
  ): Promise<AxiosResponse<void>> {
    const url = '/notification/api/Notification/updateInfo'
    return axiosClient.put(url, payload)
  },

  healthCheck(): Promise<AxiosResponse<any>> {
    const url = '/notification/api/HealthCheck'
    return axiosClient.get(url)
  },
}

export default notificationApi
